import { useEffect, useState, type FormEvent, type ReactNode } from "react";
import { LockKeyhole } from "lucide-react";
import { Button, Field, LoadingState } from "@/components/ui";

const bypassGate = import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_API !== "false";

export function StagingAuthGate({ children }: { children: ReactNode }) {
  const [authenticated, setAuthenticated] = useState<boolean | null>(bypassGate ? true : null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (bypassGate) return;
    void fetch("/api/leads/session", { credentials: "same-origin" })
      .then(async (response) => setAuthenticated(response.ok && Boolean((await response.json() as { authenticated?: boolean }).authenticated)))
      .catch(() => setAuthenticated(false));
    const expired = () => setAuthenticated(false);
    window.addEventListener("charehyar:auth-required", expired);
    return () => window.removeEventListener("charehyar:auth-required", expired);
  }, []);

  async function login(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError("");
    try {
      const response = await fetch("/api/leads/session", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ password }) });
      if (!response.ok) throw new Error("رمز ورود معتبر نیست.");
      setPassword(""); setAuthenticated(true);
    } catch (cause) { setError(cause instanceof Error ? cause.message : "ورود انجام نشد."); }
    finally { setBusy(false); }
  }

  if (authenticated === null) return <LoadingState label="در حال بررسی دسترسی محیط آزمایشی…" />;
  if (!authenticated) return <main className="staging-login" dir="rtl"><section className="staging-login__card"><LockKeyhole /><span>محیط آزمایشی چاره‌یار</span><h1>ورود به موتور کشف لید</h1><p>این محیط داخلی است. برای ادامه رمز staging را وارد کنید.</p><form onSubmit={(event) => void login(event)}><Field label="رمز محیط آزمایشی" error={error || undefined}><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></Field><Button type="submit" disabled={busy || !password}>{busy ? "در حال ورود…" : "ورود امن"}</Button></form></section></main>;
  return children;
}
